var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLivingroomlittle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14.17 13.48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: #5b5757;\n      }"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.39,6.14h-.25c0,1.11-.45,2.11-1.17,2.83-.72.72-1.72,1.17-2.83,1.17s-2.1-.45-2.83-1.17c-.72-.72-1.17-1.72-1.17-2.83s.45-2.11,1.17-2.83c.73-.72,1.72-1.17,2.83-1.17s2.11.45,2.83,1.17c.73.73,1.17,1.72,1.17,2.83h.5c0-2.49-2.02-4.5-4.5-4.5S2.64,3.65,2.64,6.14s2.02,4.5,4.5,4.5,4.5-2.02,4.5-4.5h-.25Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "7.09 13.07 7.28 13.34 14.17 8.33 11.47 0 2.71 0 0 8.33 7.09 13.48 7.28 13.34 7.09 13.07 7.28 12.8 0.78 8.08 3.19 0.66 10.98 0.66 13.39 8.08 6.89 12.8 7.09 13.07 7.28 12.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivingroomlittle);
export default __webpack_public_path__ + "static/media/livingroomlittle.80987a6ee7b13040ffb850df399d8756.svg";
export { ForwardRef as ReactComponent };